module.exports = __webpack_public_path__ + "static/media/arm.f4717829.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/arm.png
// module id = 117
// module chunks = 0